<template lang="pug">

  text-input(name="zip", :label="label", meta)

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-zip',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'Zip',
    },
  },
}

</script>
